var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#25282F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,22.3l-0.6-1.7c1-0.4,1.7-1.3,1.7-2.3v-2.7c0-1.4-1.3-2.5-2.9-2.5h-0.8c-1.6,0-2.9,1.1-2.9,2.5v2.7 c0,0.9,0.6,1.7,1.4,2.1c0.7,0.3,1.1,0.9,1.1,1.6v0.2c-2.6,0.1-5,1-6.9,2.3c-0.2,0.2-0.2,0.5,0.1,0.6c3.6,0.8,6.7,2.4,9.3,4.5 c0.4,0.3,0.9,0.4,1.4,0.2c2.3-1.1,3.6-1.9,5.5-3.1c0.4-0.2,0.5-0.7,0.1-1.1C41.7,23.9,39.8,22.7,36.9,22.3L36.9,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,26.5l-0.6-1.6c1.2-0.3,2.1-1.3,2.1-2.4v-6c0-1.4-1.3-2.5-2.9-2.5h-1.9c-1.6,0-2.9,1.1-2.9,2.5v6 c0,0.9,0.5,1.7,1.3,2.1c0.7,0.4,1.2,1.1,1.2,1.9c-4.2,0.3-8,2.1-10.6,4.7c-0.3,0.3-0.3,0.7,0,0.9c2.9,2.9,7.1,4.8,11.9,4.8 s8.5-2.8,12.4-5c0.4-0.2,0.5-0.7,0.1-1C30.3,28.4,26.8,26.9,22.7,26.5L22.7,26.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.51230ccc29999fc48dc3dc107360b8f8.svg";
export { ForwardRef as ReactComponent };